import React from 'react';

const Footer = () => <div className='g-verstion'>Version 2.64.50.174</div>;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/footer/index.js